import React from 'react';

const SystemManagementPage: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">시스템 관리</h1>
      <p className="text-gray-600">시스템 관리 페이지가 여기에 표시됩니다.</p>
    </div>
  );
};

export default SystemManagementPage;
